import { IS_PUBLIC_ACCESS_RESTRICTED_KEY, IS_PUBLIC_ACCESS_RESTRICTED } from '@/constants/constants';


export default function isPublicAccessRestricted(to, from, next) {
  const isRouteRestricted = to.matched.some(r => r.meta[IS_PUBLIC_ACCESS_RESTRICTED_KEY]);

  if (isRouteRestricted && IS_PUBLIC_ACCESS_RESTRICTED) {
    next({ name: 'password-restoration' });
    return;
  }

  next();
}
